/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetStaffMemberQueryResponse, GetStaffMemberPathParams, GetStaffMember400, GetStaffMember401, GetStaffMember403, GetStaffMember404, GetStaffMember409, GetStaffMember500 } from "../../types/staffController/GetStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getStaffMember } from "../../client/staffController/getStaffMember.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getStaffMemberQueryKey = (organizationId: GetStaffMemberPathParams["organizationId"] | undefined, staffId: GetStaffMemberPathParams["staffId"] | undefined) => [{ url: '/api/organizations/:organizationId/staff/:staffId', params: {organizationId:organizationId,staffId:staffId} }] as const

export type GetStaffMemberQueryKey = ReturnType<typeof getStaffMemberQueryKey>

export function getStaffMemberQueryOptions(organizationId: GetStaffMemberPathParams["organizationId"] | undefined, staffId: GetStaffMemberPathParams["staffId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getStaffMemberQueryKey(organizationId, staffId)
        return queryOptions<GetStaffMemberQueryResponse, ResponseErrorConfig<GetStaffMember400 | GetStaffMember401 | GetStaffMember403 | GetStaffMember404 | GetStaffMember409 | GetStaffMember500>, GetStaffMemberQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && staffId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getStaffMember(organizationId!, staffId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get staff member by ID
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export function useGetStaffMember<TData = GetStaffMemberQueryResponse, TQueryData = GetStaffMemberQueryResponse, TQueryKey extends QueryKey = GetStaffMemberQueryKey>(organizationId: GetStaffMemberPathParams["organizationId"] | undefined, staffId: GetStaffMemberPathParams["staffId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetStaffMemberQueryResponse, ResponseErrorConfig<GetStaffMember400 | GetStaffMember401 | GetStaffMember403 | GetStaffMember404 | GetStaffMember409 | GetStaffMember500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getStaffMemberQueryKey(organizationId, staffId)
         

         const query = useQuery({
          ...getStaffMemberQueryOptions(organizationId, staffId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetStaffMember400 | GetStaffMember401 | GetStaffMember403 | GetStaffMember404 | GetStaffMember409 | GetStaffMember500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}